import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Appel JS en cours ...");
        super.connect();
        var self = this;
       /* document.addEventListener("click", function (evt) {
            if (self.isopened == 1 && evt.target.id != "main") {
                if (
                    evt.target.style.zIndex <
                    document.getElementById("mySidebar").style.zIndex
                ) {
                    self.toggle();
                } else {
                    //console.log("Clicked outside")
                    //  document.getElementById("flyout-debug").textContent = "Clicked outside!";
                }
            } else {
                //console.log("Mais cest pas ouvert");
            }
        });*/
        console.log("current app: " + this.current_app)
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            //this.show_edition_multiple();
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
        }
    }

    get params() {
        return this.data.get("params");
    }

    get appel_ids() {
        return this.data.get("appel_ids");
    }

    get appel_id() {
        return this.data.get("appel_id");
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("url-solution");
    }
}
